// extracted by mini-css-extract-plugin
export var orderSummary = "_t4-0";
export var showMoreLessButton = "_t4-1";